import { Typography } from "antd";
import { Link } from "react-router-dom";
import { ConnectedProps } from "react-redux";

import { NavigationPath, history } from "../../../utils";
import connector from "./Container";

const InsuranceHomeHeader = ({ state }: ConnectedProps<typeof connector>) => {
  const { loggedUser } = state;
  const isRequests = history.location.pathname.includes(
    NavigationPath.INSURANCE_OFFER_REQUESTS_ROUTE
  );

  return (
    <>
      <div className="px-8 pt-4">
        <Typography className="text-xl font-bold text-secondary py-3">
          {loggedUser?.organization.name}
        </Typography>
        <div className="mt-4">
          <Link
            to={NavigationPath.INSURANCE_OFFER_REQUESTS_ROUTE}
            className={`text-base ${
              isRequests
                ? "text-offer-blue border-b-2 border-offer-blue"
                : "text-secondary"
            } `}
          >
            Zahtjevi za ponude
          </Link>
          <Link
            to={NavigationPath.ORDERS_ROUTE}
            className={`ml-8 text-base ${
              !isRequests
                ? "text-offer-blue border-b-2 border-offer-blue"
                : "text-secondary"
            } `}
          >
            Nalozi
          </Link>
        </div>
      </div>
      <div className="h-5 bg-base-gray"></div>
    </>
  );
};

export default InsuranceHomeHeader;
